import React from "react";

var Lockup = function Lockup(_ref) {
  var id = _ref.id,
      slug = _ref.slug,
      title = _ref.title,
      type = _ref.type,
      excerpt = _ref.excerpt,
      number = _ref.number,
      cover = _ref.cover;
  var numberString = number ? "".concat(number, ": ") : "";
  var coverSrc = cover || "https://source.unsplash.com/abkEAOjnY0s";
  coverSrc += "/420x420";
  return React.createElement("li", {
    className: "lockup",
    id: id
  }, React.createElement("header", null, React.createElement("h3", {
    className: "lockup__title"
  }, React.createElement("a", {
    className: "lockup__title-link",
    href: slug
  }, numberString, title)), React.createElement("p", {
    className: "lockup__categories"
  }, React.createElement("i", {
    className: "fal fa-book icon icon--display-5"
  }), type)), React.createElement("p", {
    className: "lockup__lead"
  }, excerpt), React.createElement("div", {
    className: "lockup__banner"
  }, React.createElement("img", {
    src: coverSrc,
    alt: ""
  })), React.createElement("a", {
    className: "lockup__link btn",
    href: slug
  }, "Get started"));
};

export default Lockup;